import { render, staticRenderFns } from "./pc-footer.vue?vue&type=template&id=2f838484&scoped=true"
import script from "./pc-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./pc-footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./pc-footer.vue?vue&type=style&index=0&id=2f838484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f838484",
  null
  
)

export default component.exports